<template>
    <div class="container-fluid">
        <!-- breadbrumb -->
        <app-breadcrumb pageTitle="Shoppers"></app-breadcrumb>

        <!-- count -->
        <div class="row">
            <div class="col-md-9 col-12">
                <p class="">
                    <span class="h3">{{myShoppersCount}}</span>
                </p>
            </div>
        </div>
        <!-- search & filters -->
        <div class="row">
            <div class="col-12">
                <div class="input-group">
                    <input type="text" v-model="searchBox" @keyup="performSearch" class="form-control no-lines bg-white" placeholder="search my shoppers">
                    <div class="input-group-prepend">
                        <div class="input-group-text bg-dark-green text-light"><i class="fas fa-search"></i></div>
                    </div>
                </div>
            </div>
        </div>
        <!-- shoppers -->
        <div class="row my-3">
            <div class="col-12">
                <div class="table-responsive">
                    <table class="table table-striped mt-2">
                        <thead class="bg-silver">
                            <tr v-if="countRecords">
                                <td colspan="5" class="bg-white p-1" style="border: 0px;">
                                    Showing 
                                    <select @change="modifyLimit(recordsLimit)" v-model="recordsLimit">
                                        <option v-for="(x, i) in countRecords.steps" :key="i" :value="x">{{x}}</option>
                                    </select> 
                                    of {{countRecords.total}} records
                                </td>
                            </tr>
                            <tr>
                                <th>S/N</th>
                                <th>myShoppers</th>
                                <th>Purchased</th>
                            </tr>
                        </thead>
                        <tbody v-if="myShoppers">
                            <router-link :to="{ name: 'shoppersId', params: { id: shopper.id } }" tag="tr" class="clickable" v-for="(shopper, i) in shoppersArr" :key="i">
                                <td>{{i+1}}.</td>
                                <td class="p-1">
                                    <div class="d-inline-flex">
                                        <div class="mr-2">
                                            <img v-if="shopper.dp" :src="myProfilePhoto(shopper.dp)" 
                                            class="message-user-photo rounded-circle img-thumbnail">
                                            <i v-else class="far fa-user-circle fa-3x"></i>
                                        </div>
                                        <p class="m-0">
                                            <span class="text-dark text-capitalize">{{shopper.name}}</span><br>
                                            <router-link :to="{ name: 'lookup-handle', params: { handle: shopper.handle} }" class="text-dark-green">
                                                @{{shopper.handle}}
                                            </router-link>
                                        </p>
                                    </div>
                                </td>
                                <td>{{shopper.purchased}} Item(s)</td>
                            </router-link>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { appendImgHostUrl, paginateRecords, fuzzySearch } from '@/store/dry'
import { mapActions, mapGetters } from 'vuex'

import Fuse from 'fuse.js'
import Breadcrumb from '../shared/Breadcrumb.vue'
import LayoutShop from '@/layouts/Shop.vue'

export default {
    name: "Shoppers",
    data() {
        return {
            searchBox: '',
            recordsLimit: 0,
            shoppersArr: []
        }
    },
    methods: {
        ...mapActions(['fetchShoppers']),
        myProfilePhoto(path) {
            if(!path) return ''
            return appendImgHostUrl(path)
        },
        modifyLimit(limit) {
            this.recordsLimit = limit
        },
        performSearch() {
            if(!this.myShoppers.length) { return }
            if(!this.searchBox.length){
                return this.shoppersArr = this.myShoppers
            } 
            else {
                // use fuzzySearch to perform search
                const searchOptions = {
                    keys: [
                        "name",
                        "handle"
                    ]
                };
                this.shoppersArr = fuzzySearch(Fuse, this.myShoppers, searchOptions, this.searchBox)
            }
        }
    },
    computed: {
        ...mapGetters(['shoppers']),
        myShoppers() {
            if(this.shoppers && this.shoppers.length){
                this.shoppersArr = this.shoppers
                return this.shoppers
            }
            return false
        },
        myShoppersCount(){
            if(this.myShoppers){
                if(this.myShoppers.length < 2){
                    return `${this.myShoppers.length} Shopper`
                }
                return `${this.myShoppers.length} Shoppers`
            }
            return `0 Shopper`
        },
        countRecords() {
            if(this.shoppers && this.shoppers.length){
                let resultObj = paginateRecords(this.shoppers, 9)
                this.recordsLimit = resultObj.steps[0]
                return resultObj
            }
            return false
        },
    },
    components: {
        appBreadcrumb: Breadcrumb
    },
    created() {
        this.fetchShoppers().then(() => {}).catch((e) => {})
        this.$emit('update:layout', LayoutShop);
    }
}
</script>